import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "text-title-underline mb-4" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "flex flex-col md:flex-row md:justify-between md:items-center" }
const _hoisted_5 = { class: "mb-1 border-b border-gray-500 w-full mr-5 flex items-center" }
const _hoisted_6 = { class: "mr-10" }
const _hoisted_7 = { class: "text-orange-700" }
const _hoisted_8 = { class: "flex justify-end md:w-full md:justify-end mt-2 md:mt-0" }
const _hoisted_9 = { class: "bg-white shadow-md p-4 text-sm md:text-base border-2 border-mentalncText" }
const _hoisted_10 = {
  key: 0,
  class: "mb-0.5 flex justify-end"
}
const _hoisted_11 = { class: "border border-gray-700 rounded p-1 w-full mb-6" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "p-2" }
const _hoisted_14 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12" }
const _hoisted_15 = { class: "col-span-2" }
const _hoisted_16 = { class: "font-bold mr-1" }
const _hoisted_17 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100" }
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = { class: "flex mb-1 col-span-4 md:col-span-8" }
const _hoisted_20 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_21 = { class: "text-sm ml-1" }
const _hoisted_22 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12" }
const _hoisted_23 = { class: "col-span-2" }
const _hoisted_24 = { class: "flex mb-1 col-span-4 md:col-span-8" }
const _hoisted_25 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_26 = { class: "text-sm ml-1" }
const _hoisted_27 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100" }
const _hoisted_28 = { class: "col-span-2" }
const _hoisted_29 = { class: "flex mb-1 col-span-4 md:col-span-8" }
const _hoisted_30 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_31 = { class: "text-sm ml-1" }
const _hoisted_32 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12" }
const _hoisted_33 = { class: "col-span-2" }
const _hoisted_34 = { class: "flex mb-1 col-span-4 md:col-span-8" }
const _hoisted_35 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_36 = { class: "text-sm ml-1" }
const _hoisted_37 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100" }
const _hoisted_38 = { class: "col-span-2" }
const _hoisted_39 = { class: "flex mb-1 col-span-4 md:col-span-8" }
const _hoisted_40 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_41 = { class: "text-sm ml-1" }
const _hoisted_42 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12" }
const _hoisted_43 = { class: "col-span-2" }
const _hoisted_44 = { class: "flex mb-1 col-span-4 md:col-span-8" }
const _hoisted_45 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_46 = { class: "text-sm ml-1" }
const _hoisted_47 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12 bg-gray-100" }
const _hoisted_48 = { class: "col-span-4 md:col-span-10" }
const _hoisted_49 = { class: "border border-gray-700 rounded p-1 w-full mb-6" }
const _hoisted_50 = { class: "flex items-center" }
const _hoisted_51 = { class: "p-2" }
const _hoisted_52 = { class: "mb-2 p-2 grid grid-cols-4 md:grid-cols-12" }
const _hoisted_53 = { class: "col-span-2" }
const _hoisted_54 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100" }
const _hoisted_55 = { class: "col-span-3 md:col-span-5" }
const _hoisted_56 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_57 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_58 = { class: "text-sm ml-1" }
const _hoisted_59 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12" }
const _hoisted_60 = { class: "col-span-6 md:col-span-10" }
const _hoisted_61 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100" }
const _hoisted_62 = { class: "col-span-6 md:col-span-5" }
const _hoisted_63 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_64 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_65 = { class: "text-sm ml-1" }
const _hoisted_66 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12" }
const _hoisted_67 = { class: "col-span-6 md:col-span-10" }
const _hoisted_68 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100" }
const _hoisted_69 = { class: "col-span-6 md:col-span-10" }
const _hoisted_70 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12" }
const _hoisted_71 = { class: "col-span-3 md:col-span-5" }
const _hoisted_72 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_73 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_74 = { class: "text-sm ml-1" }
const _hoisted_75 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100" }
const _hoisted_76 = { class: "col-span-6 md:col-span-5" }
const _hoisted_77 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_78 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_79 = { class: "text-sm ml-1" }
const _hoisted_80 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12" }
const _hoisted_81 = { class: "col-span-6 md:col-span-10" }
const _hoisted_82 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100" }
const _hoisted_83 = { class: "col-span-3 md:col-span-5" }
const _hoisted_84 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_85 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_86 = { class: "text-sm ml-1" }
const _hoisted_87 = { class: "border border-gray-700 rounded p-1 w-full mb-6" }
const _hoisted_88 = { class: "flex items-center" }
const _hoisted_89 = { class: "p-2" }
const _hoisted_90 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12" }
const _hoisted_91 = { class: "col-span-6 md:col-span-5" }
const _hoisted_92 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_93 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_94 = { class: "text-sm ml-1" }
const _hoisted_95 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100" }
const _hoisted_96 = { class: "col-span-3 md:col-span-5" }
const _hoisted_97 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_98 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_99 = { class: "text-sm ml-1" }
const _hoisted_100 = { class: "border border-gray-700 rounded p-1 w-full mb-6" }
const _hoisted_101 = { class: "flex items-center" }
const _hoisted_102 = { class: "p-2" }
const _hoisted_103 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12" }
const _hoisted_104 = { class: "col-span-3 md:col-span-5" }
const _hoisted_105 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_106 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_107 = { class: "text-sm ml-1" }
const _hoisted_108 = { class: "mb-2 p-2 grid grid-cols-6 md:grid-cols-12 bg-gray-100" }
const _hoisted_109 = { class: "col-span-3 md:col-span-5" }
const _hoisted_110 = { class: "flex mb-1 col-span-6 md:col-span-5" }
const _hoisted_111 = {
  key: 0,
  class: "flex items-center ml-2 text-gray-700"
}
const _hoisted_112 = { class: "text-sm ml-1" }
const _hoisted_113 = {
  key: 1,
  class: "padding-auth-contents"
}
const _hoisted_114 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('counselingReports.title')), 1),
            (_ctx.counselingReportDetails)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_router_link, {
                      class: "text-xs md:text-sm text-blue-500 hover:text-blue-400 hover:border-b border-blue-400",
                      to: "/counseling-reports/"
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode(" ＜ カウンセリングレポート一覧へ戻る ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, " レポートID：" + _toDisplayString(_ctx.counselingReportDetails.id), 1),
                      _createElementVNode("div", _hoisted_7, " カウンセラー：" + _toDisplayString(_ctx.counselingReportDetails.user.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.user.user.id === _ctx.counselingReportDetails.user_id)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("button", {
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyReport && _ctx.copyReport(...args))),
                              class: "text-gray-700 flex justify-center items-center w-28 py-1 bg-white border border-gray-700 hover:bg-gray-50 rounded mb-2 mr-2"
                            }, [
                              _createVNode(_component_base_svg_icon, {
                                class: "min-w-[1.3rem] mr-1",
                                path: _ctx.mdiContentCopy
                              }, null, 8, ["path"]),
                              _cache[6] || (_cache[6] = _createElementVNode("div", null, "複製", -1))
                            ]),
                            _createElementVNode("button", {
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editReport && _ctx.editReport(...args))),
                              class: "text-mentalncText flex justify-center items-center w-28 py-1 bg-white border border-mentalncText hover:bg-gray-50 rounded mb-2 mr-2"
                            }, [
                              _createVNode(_component_base_svg_icon, {
                                class: "min-w-[1.3rem] mr-1",
                                path: _ctx.mdiFileEdit
                              }, null, 8, ["path"]),
                              _cache[7] || (_cache[7] = _createElementVNode("div", null, "編集", -1))
                            ]),
                            _createElementVNode("button", {
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.viewDeleteCheck && _ctx.viewDeleteCheck(...args))),
                              class: "text-red-500 flex justify-center items-center w-28 py-1 bg-white border border-red-600 hover:bg-gray-50 rounded mb-2"
                            }, [
                              _createVNode(_component_base_svg_icon, {
                                class: "min-w-[1.3rem] mr-1",
                                path: _ctx.mdiDelete
                              }, null, 8, ["path"]),
                              _cache[8] || (_cache[8] = _createElementVNode("div", null, "削除", -1))
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.counselingReportDetails.user_id === _ctx.userId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", {
                            class: _normalizeClass(["px-3 rounded-full text-white", _ctx.counselingReportDetails.is_hidden ? 'bg-gray-500' : 'bg-green-500'])
                          }, _toDisplayString(_ctx.counselingReportDetails.is_hidden ? 'レポート非公開中' : 'レポート公開中'), 3)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("fieldset", _hoisted_11, [
                      _createElementVNode("legend", _hoisted_12, [
                        _createVNode(_component_base_svg_icon, {
                          class: "w-7 md:w-7 mr-1",
                          path: _ctx.mdiAccount
                        }, null, 8, ["path"]),
                        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-lg font-bold" }, "クライアント情報", -1))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "ニックネーム"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-200 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("p", null, [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.counselingReportDetails.counseling_client.nick_name), 1),
                              _cache[10] || (_cache[10] = _createTextVNode("さん", -1))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "年齢"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.counseling_client.age), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            (_ctx.counselingReportDetails.counseling_client.age_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.counselingReportDetails.counseling_client.age_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "性別"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.counseling_client.gender), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            (_ctx.counselingReportDetails.counseling_client.gender_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.counselingReportDetails.counseling_client.gender_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "居住地"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.counseling_client.residence), 1)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            (_ctx.counselingReportDetails.counseling_client.residence_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.counselingReportDetails.counseling_client.residence_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "出身地"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.counseling_client.birthplace), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            (_ctx.counselingReportDetails.counseling_client.birthplace_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.counselingReportDetails.counseling_client.birthplace_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "兄弟構成"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.counseling_client.sibling), 1)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            (_ctx.counselingReportDetails.counseling_client.sibling_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.counselingReportDetails.counseling_client.sibling_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "生育環境"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.counseling_client.circumstance), 1)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            (_ctx.counselingReportDetails.counseling_client.circumstance_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.counselingReportDetails.counseling_client.circumstance_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex col-span-4 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "詳細な生育環境"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.counseling_client.circumstance_others_detail), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("fieldset", _hoisted_49, [
                      _createElementVNode("legend", _hoisted_50, [
                        _createVNode(_component_base_svg_icon, {
                          class: "w-7 md:w-7 mr-1",
                          path: _ctx.mdiLaptopAccount
                        }, null, 8, ["path"]),
                        _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "text-lg font-bold" }, "セッション詳細", -1))
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "flex col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "実施日"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.dayjs(_ctx.counselingReportDetails.implementation_date).format('YYYY年MM月DD日')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "flex col-span-3 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "形式"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.session_format), 1)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            (_ctx.counselingReportDetails.session_format_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.counselingReportDetails.session_format_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "flex col-span-6 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "クライアントの主訴"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.client_concerns), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "flex col-span-6 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "セッションテーマ"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_62, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counselingReportDetails.counseling_session_themes, (theme) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "grid-cols-1 mr-2",
                                key: theme.id
                              }, [
                                _createElementVNode("p", {
                                  style: _normalizeStyle({ color: theme.theme_color }),
                                  class: "text-xs md:text-sm"
                                }, [
                                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-black" }, "・", -1)),
                                  _createTextVNode(_toDisplayString(theme.session_theme_name), 1)
                                ], 4)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            (_ctx.counselingReportDetails.session_theme_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.counselingReportDetails.session_theme_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex col-span-6 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "セッションのG"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.session_g), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex col-span-6 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "セッションのR"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.session_r), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "flex col-span-3 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "セッションの種別"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.session_type), 1)
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            (_ctx.counselingReportDetails.session_type_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_74, _toDisplayString(_ctx.counselingReportDetails.session_type_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "flex col-span-6 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "扱ったノイズ"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_76, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counselingReportDetails.counseling_mental_noises, (theme) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "mr-2",
                                key: theme.id
                              }, [
                                _createElementVNode("p", {
                                  style: _normalizeStyle({ color: theme.theme_color }),
                                  class: "text-xs md:text-sm"
                                }, [
                                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "text-black" }, "・", -1)),
                                  _createTextVNode(_toDisplayString(theme.mental_noise_name), 1)
                                ], 4)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            (_ctx.counselingReportDetails.session_mentalnoise_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.counselingReportDetails.session_mentalnoise_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex col-span-6 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "セッション後の所見等"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.session_findings), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "flex col-span-3 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "時間"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.session_time), 1)
                          ]),
                          _createElementVNode("div", _hoisted_84, [
                            (_ctx.counselingReportDetails.session_time_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_86, _toDisplayString(_ctx.counselingReportDetails.session_time_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("fieldset", _hoisted_87, [
                      _createElementVNode("legend", _hoisted_88, [
                        _createVNode(_component_base_svg_icon, {
                          class: "w-7 md:w-7 mr-1",
                          path: _ctx.mdiChartLine
                        }, null, 8, ["path"]),
                        _cache[32] || (_cache[32] = _createElementVNode("h2", { class: "text-lg font-bold" }, "経過", -1))
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "flex col-span-6 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2 text-sm" }, "前回からのクライアントの現実変化"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_91, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counselingReportDetails.counseling_client_changeds, (changed) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "grid-cols-1 mr-2",
                                key: changed.id
                              }, " ・" + _toDisplayString(changed.client_changed_name), 1))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            (_ctx.counselingReportDetails.session_changed_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_94, _toDisplayString(_ctx.counselingReportDetails.session_changed_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _cache[34] || (_cache[34] = _createElementVNode("div", { class: "flex col-span-3 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "継続予定"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.continue_plan), 1)
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            (_ctx.counselingReportDetails.continue_plan_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_99, _toDisplayString(_ctx.counselingReportDetails.continue_plan_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("fieldset", _hoisted_100, [
                      _createElementVNode("legend", _hoisted_101, [
                        _createVNode(_component_base_svg_icon, {
                          class: "w-7 md:w-7 mr-1",
                          path: _ctx.mdiHandshake
                        }, null, 8, ["path"]),
                        _cache[35] || (_cache[35] = _createElementVNode("h2", { class: "text-lg font-bold" }, "ビジネスについて", -1))
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", _hoisted_103, [
                          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "flex col-span-3 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "経路"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_104, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.client_route), 1)
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            (_ctx.counselingReportDetails.client_route_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_107, _toDisplayString(_ctx.counselingReportDetails.client_route_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _cache[37] || (_cache[37] = _createElementVNode("div", { class: "flex col-span-3 md:col-span-2 justify-between" }, [
                            _createElementVNode("p", { class: "font-bold ml-2" }, "価格"),
                            _createElementVNode("p", { class: "border-r-4 border-gray-300 mr-2" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.counselingReportDetails.session_price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_110, [
                            (_ctx.counselingReportDetails.session_price_others)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                  _createVNode(_component_base_svg_icon, {
                                    class: "min-w-[1rem]",
                                    path: _ctx.mdiCommentTextOutline
                                  }, null, 8, ["path"]),
                                  _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.counselingReportDetails.session_price_others), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_113, " カウンセリングレポートが見つかりませんでした。 "))
          ]),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.dialogVisible,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
            title: "確認画面",
            width: _ctx.store.state.base.responsive.isMD ? '80%' : '40%'
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_114, [
                _createVNode(_component_el_button, {
                  class: "text-gray-600",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = false))
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("キャンセル", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "text-gray-600",
                  type: "danger",
                  onClick: _ctx.deleteReport
                }, {
                  default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                    _createTextVNode(" 削除 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _cache[40] || (_cache[40] = _createElementVNode("span", null, "このカウンセリングレポートを削除しますか？", -1))
            ]),
            _: 1
          }, 8, ["modelValue", "width"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}